import { adalApiFetch } from '../../adalConfig';

const uri = process.env.REACT_APP_BASE_URL;

const buildQueryString = (params) => {
    if (params instanceof URLSearchParams) {
        const queryParams = new URLSearchParams();

        for (const [key, value] of params.entries()) {
            if (value === undefined || value === null) {
                continue;
            }

            queryParams.append(key, value);
        }

        return queryParams.toString();
    }

    const queryParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return;
        }

        queryParams.append(key, value);
    });

    return queryParams.toString();
};

export const getAPIData = async (path, stateSet, abortController) => {
    var options = null
    if (abortController) {
        options = { signal: abortController.signal };
    }
    const response = await adalApiFetch(fetch, uri + path, options);
    const data = await response.json();
    stateSet(data);
}

export const getAPIDataParams = async (path, stateSet, params, abortController) => {
    var options = null
    if (abortController) {
        options = { signal: abortController.signal };
    }
    const response = await adalApiFetch(fetch, uri + path + '?' + buildQueryString(params), options);
    try {
        const data = await response.json();
        stateSet(data);
    } catch (e) {
        stateSet(null);
    }
}
export const getAPIDataParamsReturn = async (path, params, abortController) => {
    var options = null
    if (abortController) {
        options = { signal: abortController.signal };
    }
    const response = await adalApiFetch(fetch, uri + path + '?' + buildQueryString(params), options );
    const data = await response.json();
    return (data);
}
export const getAPIDataReturn = async (path, abortController) => {
    var options = null
    if (abortController) {
        options = { signal: abortController.signal };
    }
    const response = await adalApiFetch(fetch, uri + path, options);
    const data = await response.json();
    return (data);
}

export const handlePagination = async (fetch, url, startDate, endDate, extraParams, abortController) => {
    var options = null
    if (abortController) {
        options = { signal: abortController.signal };
    }
    const response = await adalApiFetch(fetch, url + '?' + buildQueryString({
        ...extraParams,
        startDate,
        endDate
    }), options);
    var retData = [];
    var data = await response.json();
    if (data.cursor >= data.length) {
        retData = data.list;
    } else {
        retData = [...data.list, ...(await handlePagination(fetch, url, startDate, endDate, { start: (data.cursor ) }, abortController))];
    }
    return retData;
}

export const postApi = async (path, params) => {
    return await adalApiFetch(fetch, uri + path + '?' + buildQueryString(params), {
        method: 'post',
    });
}

export const getApiErrorMessage = async (response, fallback = 'Failed to submit') => {
    try {
        const value = await response.clone().json();
        if (typeof value === 'string') {
            return value;
        }
        return value?.detail || value?.message || value?.title || fallback;
    } catch {
        const value = await response.text();
        return value || fallback;
    }
}

export const postApiOrThrow = async (path, params) => {
    const response = await postApi(path, params);
    if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
    }
    return response;
}

export const postApiJson = async (path, body) => {
    return await adalApiFetch(fetch, uri + path, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
    });
}

export const putApiJson = async (path, body) => {
    return await adalApiFetch(fetch, uri + path, {
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
    });
}

export const deleteApi = async (path) => {
    return await adalApiFetch(fetch, uri + path, {
        method: 'delete',
    });
}